import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const $sliders = $( '.service-slider__splide' );
      if ( !$sliders.length ) return;

      $sliders.each( function() {
        const element = this;

        const slider = new Splide( element, {
          type: 'loop',
          gap: '2rem',
          perPage: 4,
          perMove: 1,
          pagination: false,
          speed: 800,
          arrows: false,
          breakpoints: {
            768: {
              perPage: 1,
              gap: '1rem',
            },
          },
        } );

        const featuredBlock = element.closest( '[data-component="featured-services"]' );

        if ( !featuredBlock ) return;

        // grab arrows (simplified + reliable)
        const arrowsDesktop = featuredBlock.querySelector( '.js-splide-arrows--desktop' );
        const arrowsMobile = featuredBlock.querySelector( '.js-splide-arrows--mobile' );

        const bindArrows = ( wrapper ) => {
          if ( !wrapper ) return;

          const prev = wrapper.querySelector( '.splide__arrow--prev' );
          const next = wrapper.querySelector( '.splide__arrow--next' );

          if ( prev && !prev.dataset.bound ) {
            prev.addEventListener( 'click', () => slider.go( '<' ) );
            prev.dataset.bound = 'true';
          }

          if ( next && !next.dataset.bound ) {
            next.addEventListener( 'click', () => slider.go( '>' ) );
            next.dataset.bound = 'true';
          }
        };

        slider.on( 'mounted', () => {
          const slideCount = slider.Components.Slides.getLength();
          const shouldShow = slideCount > 3;

          if ( arrowsDesktop ) arrowsDesktop.style.display = shouldShow ? 'flex' : 'none';
          if ( arrowsMobile ) arrowsMobile.style.display = shouldShow ? 'flex' : 'none';

          // bind AFTER mount (important fix)
          bindArrows( arrowsDesktop );
          bindArrows( arrowsMobile );
        } );

        slider.mount();
      } );
    },
    finalize: function() {},
  };
  app.registerComponent( 'service-slider', COMPONENT );
} )( app );
